import Forward from "@/views/Forward.vue";

export default (rootPath) => {
  return [
    {
      path: "",
      component: Forward,
      redirect: `${rootPath}/list`,
      hidden: true,
      children: [
        {
          path: "list",
          component: () => import("@/views/table/ShowsTable.vue"),
          meta: { title: "Список мероприятрий", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "create/:museumId",
          component: () => import("@/views/forms/ShowsForm.vue"),
          meta: { title: "Создать мероприятрие", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "edit/:id",
          component: () => import("@/views/forms/ShowsForm.vue"),
          meta: { title: "Редактировать мероприятрие", activeMenuParent: true },
          hidden: true,
        },
      ],
    },
  ];
};
